import type { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  packageContainer: {
    margin: '10px',
    width: 'calc((100% / 3) - 20px)',
    '@media (max-width: 991px)': {
      width: 'calc((100% /2) - 25px)'
    },

    '@media (max-width: 767px)': {
      width: 'calc(100%  - 25px)'
    }
  },

  cardContainer: {
    position: 'relative',
    height: '100%',
    display: 'grid',
    gridTemplateRows: '200px 1fr auto auto auto',
    '-ms-grid-rows': '200px 1fr auto auto auto'
  },

  packageDetails: {
    margin: '10px',
    flexGrow: 1,
    gridRow: 2,
    gridColumn: 1
  },

  expiryContainer: {
    margin: '5px',
    gridRow: 5,
    gridColumn: 1
  },

  fullHeight: {
    height: '100%'
  },

  imageContainer: {
    gridRow: 1,
    gridColumn: 1
  },

  longDescription: {
    minHeight: 15
  },

  safari: {
    display: 'grid'
  },

  msExplorer: {
    display: 'block'
  },

  top: {
    display: 'flex'
  },

  header: {
    flexGrow: 1
  }
}));

export default useStyles;
